// extracted by mini-css-extract-plugin
export default {"ref-cell":"styles_ref-cell__r8nZG","copy-button":"styles_copy-button__4NjqD"};